// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"b50e4419","453":"5645b79a","834":"9c9314af"}[chunkId] + ".chunk.js";
};